// extracted by mini-css-extract-plugin
export var cardContainer = "_q7-0";
export var cardHeader = "_q7-2";
export var collapsedState = "_q7-3";
export var dragHandle = "_q7-5";
export var dragHandleIcon = "_q7-6";
export var dragging = "_q7-1";
export var titleArea = "_q7-4";